import React from 'react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import Modal from '../../../components/modal'
import PrintObjectView from '../../print_object'
import Currency from '../../currency'
import PromoBadge from '../../promo_badge'
import _ from 'underscore'
import PaymentTerm from './payment_term'

class SalesOrderPartial extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showModal: false
    }
  }

  onShowData = () => {
    this.setState({ showModal: !this.state.showModal })
  }

  onHideData = () => {
    this.setState({ showModal: !this.state.showModal })
  }

  onDelete = () => {
    this.props.onDelete(this.props.order.id)
  }

  onShare = () => {
    this.props.onShare(this.props.order.id)
  }

  render() {
    const order = this.props.order

    return (
      <React.Fragment key={order.id}>
        <tr>
          <td className="align-middle" onClick={this.onShowData}>
            <Badge variant="secondary" className="cursor-pointer font-bold">{order.id}</Badge>
          </td>
          <td className="align-middle">
            {order.description}
          </td>
          <td className="align-middle">
            <PaymentTerm payment_term={order.payment_term}/>
          </td>
          <td className="align-middle">
            <Currency value={order.total} currency={order.currency_code} placeholder='-' />
            {order.promo && (
              <div className="mt-1">
                <PromoBadge promo={order.promo} />
              </div>
            )}
          </td>
          <td className="align-middle">
            {order.paid ?
              <Badge variant="success" className="font-bold">Paid</Badge>
             : <Badge variant="warning" className="font-bold">Unpaid</Badge>
            }
          </td>
          <td className="align-middle">
            <div className="flex flex-wrap items-center justify-end gap-1.5">
              <Button variant="outline" size="sm" asChild><a href={order.url} target="_blank">Customer View</a></Button>
              <Button variant="secondary" size="sm" onClick={this.onShare}>Share</Button>
              {order.actions.can_delete ?
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button variant="destructive" size="sm">Delete</Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuItem>Cancel</DropdownMenuItem>
                    <DropdownMenuItem variant="destructive" onSelect={this.onDelete}>Delete</DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
                : null
              }
            </div>
          </td>
        </tr>
        {this.state.showModal && (
          <Modal onClose={this.onHideData} title="Order Details">
            <PrintObjectView object={this.props.order} />
          </Modal>
        )}
      </React.Fragment>
    )
  }
}

export default SalesOrderPartial
